import { CrudMode, FormItem, SelectsOptions } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';
import { t } from 'i18next';

export const getLenderFormSchema = (mode?: CrudMode | null): FormItem[] => [
  {
    title: 'lender.lender.labels.lenderName',
    name: ['name'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.addressName',
    name: ['address', 'name'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.numberOrBuilding',
    name: ['address', 'numberOrBuilding'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.postCode',
    name: ['address', 'postCode'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.city',
    name: ['address', 'city'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.country',
    name: ['address', 'country'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
];

export const getLenderProcurationFeesFormSchema = (selectsOptions: SelectsOptions, mode?: CrudMode | null): FormItem[] => [
  {
    title: 'lender.lender.labels.id',
    name: 'id',
    formItemProps: {
      hidden: mode === CrudMode.CREATE,
    },
    fieldProps: {
      disabled: true,
    },
  },
  {
    title: 'lender.lender.labels.order',
    name: 'index',
    tooltip: t('lender.lender.labels.orderInfo'),
    fieldProps: {
      disabled: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRule',
    name: 'procurationFeeRuleId',
    valueType: 'select',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      optionFilterProp: 'label',
      showSearch: true,
      options: selectsOptions[FieldType.PROCURATION_FEE_RULES],
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.procurationFee',
    name: 'procurationFeeId',
    valueType: 'select',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      optionFilterProp: 'label',
      showSearch: true,
      options: selectsOptions[FieldType.PROCURATION_FEES],
      disabled: mode === CrudMode.VIEW,
    },
  },
];
